import { useTranslation } from 'react-i18next';
import { useStoreState } from 'easy-peasy';
import { selectorUser } from '@model/User';
import PropTypes from 'prop-types';

export const WelcomeMessage = ({
  labelClassName = 'rev-o-typo-primary-level-2 rev-u-lh-copy rev-u-typo-w-primary-medium',
  nameClassName = 'rev-o-typo-primary-level-3 rev-u-lh-copy rev-u-typo-w-primary-medium',
}) => {
  const { t } = useTranslation();
  const user = useStoreState(selectorUser);

  return (
    <div className="c-welcome-message c-welcome-message--homepage rev-u-text-align-right">
      <p className={labelClassName}>{t('header.welcome')}</p>

      {!!user.firstName && !!user.lastName && (
        <p className={nameClassName}>{t('common.formatting.fullName', user)}</p>
      )}
    </div>
  );
};

WelcomeMessage.propTypes = {
  labelClassName: PropTypes.string,
  nameClassName: PropTypes.string,
};
